/* ============================================================
   ctr-buy-box — gallery slider, nutrition popup, "Try It Now"
   add-to-cart (Skio subscription + free bundle + discount codes).

   ATC configuration comes from data attributes on .atc-try-it-now:
     data-variant-id       main variant
     data-selling-plan     Skio selling plan
     data-skio-group-id    Skio selling plan group
     data-bundle-variants  comma-separated free variant IDs
     data-discount-codes   comma-separated discount codes
   ============================================================ */

(function () {
  'use strict';

  var BUNDLE_TAG = 'try-it-now-bundle';

  /* ---------- Per-section UI (gallery + nutrition popup) ---------- */
  function initSection(root) {
    if (root.dataset.ctrBbInit) return;
    root.dataset.ctrBbInit = 'true';

    var thumbsEl = root.querySelector('.ctr-buy-box__thumb-slider');
    var mainEl = root.querySelector('.ctr-buy-box__main-slider');

    if (window.Swiper && thumbsEl && mainEl) {
      var thumbs = new Swiper(thumbsEl, {
        loop: true,
        spaceBetween: 10,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: thumbsEl.querySelector('.swiper-button-next'),
          prevEl: thumbsEl.querySelector('.swiper-button-prev')
        }
      });
      new Swiper(mainEl, {
        loop: true,
        spaceBetween: 10,
        thumbs: { swiper: thumbs }
      });
    }

    var openBtn = root.querySelector('.ctr-buy-box__nutrition-btn');
    var popup = root.querySelector('.ctr-buy-box__nutrition-overlay');
    var closeBtn = root.querySelector('.ctr-buy-box__nutrition-close');

    // The buy box button is optional (Content Tabs can open the popup on its
    // own), so the close handlers must not depend on it existing.
    if (popup && closeBtn) {
      function setPopup(open) {
        popup.classList.toggle('active', open);
        document.documentElement.classList.toggle('popup-open', open);
        document.body.classList.toggle('popup-open', open);
      }
      if (openBtn) openBtn.addEventListener('click', function () { setPopup(true); });
      closeBtn.addEventListener('click', function () { setPopup(false); });
      popup.addEventListener('click', function (e) {
        if (e.target === popup) setPopup(false);
      });
    }
  }

  function initAllSections() {
    document.querySelectorAll('.ctr-buy-box').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  document.addEventListener('shopify:section:load', initAllSections);

  /* ---------- Page-level cart logic (bind once) ---------- */
  if (window.__ctrBuyBoxCartInit) return;
  window.__ctrBuyBoxCartInit = true;

  /* ---------- Plan-specific gallery images (90/30 supply plans) ---------- */
  // Slides carry data-plan-src-90/30 (ctr-buy-box.liquid); Swiper's loop clones
  // copy the attributes, so every copy of a slide swaps.
  document.addEventListener('ctr-bb:plan-changed', function (e) {
    var box = e.target && e.target.closest ? e.target.closest('.ctr-buy-box') : null;
    var key = e.detail && e.detail.plan;
    if (!box || !key) return;
    box.querySelectorAll('[data-plan-src-' + key + ']').forEach(function (slide) {
      var img = slide.querySelector('img');
      var src = slide.getAttribute('data-plan-src-' + key);
      if (!img || !src || img.getAttribute('src') === src) return;
      img.removeAttribute('srcset');
      img.src = src;
    });
  });

  /* ---------- Nutrition popup triggers placed outside the buy box ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-ctr-nutrition-open]');
    if (!trigger || trigger.closest('.ctr-buy-box')) return;

    var popup = document.querySelector('.ctr-buy-box__nutrition-overlay');
    if (!popup) return;

    e.preventDefault();
    popup.classList.add('active');
    document.documentElement.classList.add('popup-open');
    document.body.classList.add('popup-open');
  });

  /* ---------- Cart drawer open/close ---------- */
  function openCartDrawer() {
    var drawer = document.getElementById('cart-drawer-kandy');
    if (!drawer) return;
    drawer.style.display = 'flex';
    drawer.classList.add('active');
    document.body.classList.add('Overflow_hidden', 'overflow-hidden');
  }

  function closeCartDrawer() {
    var drawer = document.getElementById('cart-drawer-kandy');
    if (!drawer) return;
    drawer.classList.remove('active');
    document.body.classList.remove('Overflow_hidden', 'overflow-hidden');
    setTimeout(function () { drawer.style.display = 'none'; }, 300);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('#cart-drawer-kandy .cd__nav-back')) closeCartDrawer();
  });

  document.addEventListener('click', function (e) {
    var drawer = document.getElementById('cart-drawer-kandy');
    if (!drawer || !drawer.classList.contains('active')) return;
    if (e.target.id === 'cart-drawer-kandy') closeCartDrawer();
  });

  window.openCartDrawer = window.openCartDrawer || openCartDrawer;
  window.closeCartDrawer = window.closeCartDrawer || closeCartDrawer;

  function refreshCartDrawer() {
    return fetch('/?sections=cart_drawer')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var newHTML = data.cart_drawer;
        if (!newHTML) return;

        var temp = document.createElement('div');
        temp.innerHTML = newHTML;
        var newDrawer = temp.querySelector('#cart-drawer-kandy');
        var oldDrawer = document.getElementById('cart-drawer-kandy');
        if (!newDrawer || !oldDrawer) return;

        var newInner = newDrawer.querySelector('.cd__inner');
        var oldInner = oldDrawer.querySelector('.cd__inner');
        if (newInner && oldInner) {
          oldInner.innerHTML = newInner.innerHTML;
        }

        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      });
  }

  /* ---------- "Try It Now" add-to-cart ---------- */
  function parseList(value) {
    return (value || '')
      .split(',')
      .map(function (v) { return v.trim(); })
      .filter(Boolean);
  }

  // Two pricing engines share this section, selected by the "Offer value" setting.
  // Blank means discount codes price the gifts, and `_offer` must be actively
  // blanked: cart attributes merge rather than replace, so one left behind by
  // another page would otherwise authorize its Function Studio flow here. A value
  // means the Function Studio path instead — stamp `_offer` and drop the codes so
  // only the flow can price the gifts.
  function buildCartAttributes(offerValue) {
    var attributes = { _offer: offerValue || '' };
    if (window.lpTemplateName) {
      attributes['template-name'] = window.lpTemplateName;
    }
    return attributes;
  }

  // Discount codes go to /cart/update.js (Editions '25) as one comma-separated
  // string; they're sent in the POST body, so spaces in the names are fine.
  function applyDiscounts(codes, offerValue) {
    var updatePayload = { attributes: buildCartAttributes(offerValue) };
    if (offerValue) {
      updatePayload.discount = '';
    } else if (codes.length) {
      updatePayload.discount = codes.join(',');
    }
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(updatePayload)
    }).catch(function () { /* don't block the cart if discount apply fails */ });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.atc-try-it-now');
    if (!trigger) return;
    e.preventDefault();

    if (trigger.dataset.loading === 'true') return;
    trigger.dataset.loading = 'true';
    trigger.style.opacity = '0.6';
    trigger.style.pointerEvents = 'none';

    var mainVariantId = parseInt(trigger.dataset.variantId, 10);
    var sellingPlanId = parseInt(trigger.dataset.sellingPlan, 10);
    var skioGroupId = trigger.dataset.skioGroupId;
    var bundleVariants = parseList(trigger.dataset.bundleVariants).map(Number);
    var discountCodes = parseList(trigger.dataset.discountCodes);
    var offerValue = (trigger.dataset.offer || '').trim();

    // Main subscription line FIRST, then the free bundle items. `_offer` is stamped
    // on the gift lines only, never on the paid main line, so a flow keyed on the
    // property can't discount the item the shopper is actually paying for.
    var mainQuantity = parseInt(trigger.dataset.quantity, 10) || 1;
    var items = [{
      id: mainVariantId,
      quantity: mainQuantity,
      selling_plan: sellingPlanId,
      properties: {
        _bundle: BUNDLE_TAG,
        _skio_selling_plan_group_id: skioGroupId
      }
    }];

    bundleVariants.forEach(function (id) {
      // `_gift` names the variant that earns the gift, so ctr-gift-guard can
      // drop it from any page once that variant leaves the cart.
      var properties = { _bundle: BUNDLE_TAG, _gift: String(mainVariantId) };
      if (offerValue) {
        properties._offer = offerValue;
      }
      items.push({ id: id, quantity: 1, properties: properties });
    });

    var addPayload = { items: items, attributes: buildCartAttributes(offerValue) };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(addPayload)
    })
      .then(function (res) {
        if (res.ok) return res.json();
        // Shopify explains the real reason in the body (sold out, "Cart Error"
        // for a selling plan that isn't allocated to the variant, etc.).
        return res
          .json()
          .catch(function () { return null; })
          .then(function (body) {
            var reason = (body && (body.description || body.message)) || 'HTTP ' + res.status;
            throw new Error(reason);
          });
      })
      .then(function () { return applyDiscounts(discountCodes, offerValue); })
      .then(function () { return refreshCartDrawer(); })
      .then(function () {
        window.openCartDrawer();
      })
      .catch(function (err) {
        console.error(
          'Cata-Kor ATC error:', err && err.message ? err.message : err,
          '\nvariant:', mainVariantId,
          'selling_plan:', sellingPlanId,
          'bundle:', bundleVariants
        );
        alert('Sorry, we could not add the products to your cart. Please try again.');
      })
      .finally(function () {
        trigger.dataset.loading = 'false';
        trigger.style.opacity = '';
        trigger.style.pointerEvents = '';
      });
  });

  /* ---------- Cart count badge ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function fetchAndUpdateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function (err) { console.error('Cart count fetch failed:', err); });
  }

  fetchAndUpdateCartCount();

  document.addEventListener('cart:updated', fetchAndUpdateCartCount);
  document.addEventListener('cart:refresh', fetchAndUpdateCartCount);

  var countFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
    var isCartMutation = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(urlStr);
    var result = countFetch.apply(this, arguments);
    if (isCartMutation) {
      result.then(function () { setTimeout(fetchAndUpdateCartCount, 100); }).catch(function () {});
    }
    return result;
  };

  var countOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.addEventListener('load', function () {
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
        setTimeout(fetchAndUpdateCartCount, 100);
      }
    });
    return countOpen.apply(this, arguments);
  };

  window.updateCartCount = fetchAndUpdateCartCount;
})();
